<template>
  <div class="relative flex items-start" :class="disabled ? 'cursor-not-allowed' :'cursor-pointer'">
    <div class="flex items-center h-5">
      <input :id="id" type="checkbox" v-model="enabled" :disabled="disabled"
             :class="[$parent.inputClass]"
             class="focus:ring-primary-500 h-4 w-4 text-primary-600 border-gray-300 rounded"/>
    </div>
    <div class="ml-3 text-sm">
      <label :for="id" class=" "
             :class="disabled ? 'cursor-not-allowed' :'cursor-pointer'">
        <p class="font-medium text-gray-700">{{ label }}</p>
        <p class="mt-1" :class="helpCls">{{ textHelp }}</p>
      </label>

    </div>
  </div>

</template>

<script>

import {setup, mixin} from "@/components/ui/form/mixins/BaseInput";

export default {

  setup: setup,
  mixins: [mixin],
  data() {
    return {
      enabled: this.modelValue
    }
  },

  watch: {
    modelValue(val) {
      this.enabled = val
    },
    value(val) {
      this.enabled = val
    },
    enabled(val) {
      this.input(val)
    }

  },
  computed: {
    helpCls() {
      return this.$parent?.textHelpCls ?? 'text-gray-500'
    }
  }
}
</script>
